export enum NoticeTypesEnum {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}
